export interface IFiltersNaruto {
  searchSelect: Set<string>;
  search: string;
  text: string;
  symbol: Set<string>;
  cost: Set<string>;
  entranceCost: Set<string>;
  combat: Set<string>;
  support: Set<string>;
  cardType: Set<string>;
  characteristics: Set<string>;
  showAAs: boolean;
  lang: Set<string>;
  format: Set<string>;
  set: string;
}

export default function getDefaultFilters(): IFiltersNaruto {
  return {
    searchSelect: new Set<string>(["name"]),
    search: "",
    text: "",
    format: new Set<string>(),
    symbol: new Set<string>(),
    cost: new Set<string>(),
    entranceCost: new Set<string>(),
    combat: new Set<string>(),
    support: new Set<string>(),
    cardType: new Set<string>(),
    characteristics: new Set<string>(),
    lang: new Set<string>(),
    showAAs: false,
    set: "",
  };
}
